import React, { useEffect } from 'react';
import CartStep2Tabs from './tabs';
import CartLogin from '../login/cart-login';
import { useAppSelector } from '../../data/store';
import { Step2Tabs } from '../../enums/step-2-tabs';
import CartCreateAccount from '../signup/cart-create-account';
import Step2Overview from '../overview/step-2-overview';
import { sendGaCheckoutEvent } from '../../../../../domain/marketing/gtm-provider';
import { CartSteps } from '../../enums/cart-steps';

/**
 * Shopping Cart Step #2.
 */
const CartStep2 = () => {
    const step2Tab = useAppSelector(store => store.root.step2Tab);
    const cartData = useAppSelector(store => store.root.cartData);

    /**
     * https://wavesaudio.atlassian.net/browse/DSWEB-3348
     */
    useEffect(() => {
        // jump to top
        window.scrollTo(0, 0);

        sendGaCheckoutEvent(CartSteps.Second, cartData);
    },
        // eslint-disable-next-line
        []
    );

    return (
        <div className="flex flex-wrap w-full pb-10">

            <div className="w-full md:w-7/12 lg:w-3/4 mb-6 md:mb-0">
                <div className="bg-white border rounded md:mr-3 lg:mr-6">

                    <CartStep2Tabs />

                    <div className="mx-6 my-10">
                        { step2Tab === Step2Tabs.Login && <CartLogin /> }
                        { step2Tab === Step2Tabs.CreateAccount && <CartCreateAccount /> }
                    </div>

                </div>
            </div>

            <Step2Overview />
        </div>
    )
};

export default CartStep2;